import axios from "axios";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "challenges",
  components: {},
  props: [],
  data() {
    return {
      participants: [],
      challenge: {},
      creating: false,
      commenttext: null,
      toEdit: {
        tags: [],
        path: null,
        title: null,
        description: null,
        participants: [],
        points: [],
        proof: {
          toDeliver: "",
          url: false,
          images: 0,
        },
      },
    };
  },
  computed: {
    challenges() {
      let ch = this.$store.getters.getChallenges;
      return ch.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
    paths() {
      return this.$store.getters.getPaths;
    },
    tags() {
      return this.$store.getters.getTags;
    },
    profiles() {
      return this.$store.getters.getProfiles;
    },
    users() {
      return this.$store.getters.getUsers;
    },
    me() {
      return this.$store.getters.getMyUser;
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Backend" },
      { title: "Content", route: "challenges" },
      { title: "Manage Challenges" },
    ]);
  },
  methods: {
    filterpaths() {
      return this.paths;
    },
    saveItem(item, evt) {
      console.log(evt);
      if (!item._id) {
        axios.post("challenges/", item).then((e) => {
          let path_update = this.paths.find((p) => p._id === e.data.path);
          path_update.challenge = e.data._id;
          axios.put("paths/" + path_update._id, path_update).then(() => {
            this.$store.dispatch("fetchPaths");
          });
          this.$store.dispatch("fetchChallenges");
          this.creating = !this.creating;
        });
      } else {
        axios.put("challenges/" + item._id, item).then((e) => {
          let path_update = this.paths.find((p) => p._id === e.data.path);
          path_update.challenge = e.data._id;
          axios.put("paths/" + path_update._id, path_update).then(() => {
            this.$store.dispatch("fetchPaths");
          });
          this.$store.dispatch("fetchChallenges");
          this.creating = !this.creating;
        });
      }
    },

    getProfile(profile) {
      if (profile) {
        return this.profiles.find((p) => p._id === profile);
      } else {
        return { name: "Points" };
      }
    },
    addMaterial(t) {
      switch (t) {
        case "e":
          this.toEdit.points.push({
            profile: "",
            points: "200",
          });
          break;
        case "c":
          this.toCreate.points.push({
            profile: "",
            points: "200",
          });
          break;
      }
    },
    createChallenge() {
      this.creating = !this.creating;
      this.toEdit = {
        tags: [],
        path: null,
        title: null,
        description: null,
        participants: [],
        points: [],
        proof: {
          toDeliver: "",
          url: false,
          images: 0,
        },
      };
    },
    editChallenge(chall) {
      console.log(chall);
      this.creating = !this.creating;
      this.toEdit = chall;
    },
    deleteChallenge(chall) {
      axios.delete("challenges/" + chall._id).then(() => {
        this.$store.dispatch("fetchChallenges");
      });
    },
    getStudent(student) {
      return this.users.find((u) => u._id === student);
    },
    getPath(path) {
      return this.paths.find((u) => u._id === path);
    },
    updateValid(chall, part) {
      let update = chall.participants.findIndex((p) => p._id === part._id);
      chall.participants[update].isChecked = true;
      chall.participants[update].isValid = !chall.participants[update].isValid;
      axios.put("challenges/" + chall._id, chall).then((response) => {
        this.$store.dispatch("fetchChallenges");
        console.log("r", response);
        if (chall.participants[update].isValid) {
          axios
            .put("users/" + chall.participants[update].user + "/challenge", {
              $push: { challenges: chall._id },
            })
            .then((res) => console.log("push", res));
        } else {
          axios
            .put("users/" + chall.participants[update].user + "/challenge", {
              $pull: { challenges: chall._id },
            })
            .then((res) => console.log("pull", res));
        }
      });
    },
    updateChecked(chall, part) {
      let update = chall.participants.findIndex((p) => p._id === part._id);
      chall.participants[update].isChecked = !chall.participants[update]
        .isChecked;
      axios.put("challenges/" + chall._id, chall).then((response) => {
        this.$store.dispatch("fetchChallenges");
        console.log("r", response);
      });
    },
    updateParticipants(chall, part) {
      let update = chall.participants.findIndex((p) => p._id === part._id);
      chall.participants.splice(update, 1);

      axios.put("challenges/" + chall._id, chall).then((response) => {
        this.$store.dispatch("fetchChallenges");
        console.log("r", response);
      });
    },
    viewItem(chall) {
      console.log(chall);
      this.challenge = chall;
      this.participants = chall.participants;
    },
    addComment(c, p) {
      console.log("comment", c, p, this.commenttext);
      p.proof.comments.push({
        text: this.commenttext,
        date: new Date(),
        user: this.me._id,
      });
      let proof_index = c.participants.findIndex((part) => part._id === p._id);
      c.participants[proof_index] = p;
      console.log(c.participants[proof_index]);
      axios.put("challenges/" + c._id, c).then((response) => {
        this.$store.dispatch("fetchChallenges");
        console.log("r", response);
        this.commenttext = null;
      });
    },
    getUser(u) {
      let user = this.users.find((user) => user._id === u);
      return user.firstName + " " + user.lastName;
    },
  },
};
